import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const navbarClass = isHomePage
    ? `fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled || menuOpen
          ? 'bg-[#1A2B4A] shadow-lg'
          : 'bg-transparent'
      }`
    : 'fixed top-0 left-0 right-0 z-50 bg-[#1A2B4A] shadow-lg';

  const logoTextClass = 'text-white';

  const linkClass = (path: string) => {
    const isActive = location.pathname === path;
    const base = 'font-medium transition-colors duration-300 whitespace-nowrap cursor-pointer text-sm uppercase tracking-wide';
    if (isActive) return `${base} text-[#D97642]`;
    return `${base} text-white/90 hover:text-[#D97642]`;
  };

  return (
    <nav className={navbarClass}>
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center cursor-pointer">
          <img
            src="https://static.readdy.ai/image/3968a368ec7bd5d344dd8c774c671405/4a7e3fde1e9f243c2f3bcc38a0bb7863.png"
            alt="CLOG Transport Logo"
            className="h-9 md:h-12 w-auto drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)]"
          />
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center space-x-10">
          <Link to="/" className={linkClass('/')}>Home</Link>
          <Link to="/about" className={linkClass('/about')}>About</Link>
          <Link to="/services" className={linkClass('/services')}>Services</Link>
          <Link to="/contact" className={linkClass('/contact')}>Contact</Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer text-white"
          onClick={() => setMenuOpen(prev => !prev)}
          aria-label="Toggle menu"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#1A2B4A] border-t border-white/10">
          <div className="flex flex-col px-6 py-4 space-y-4">
            <Link to="/" className="text-base font-medium text-white/90 hover:text-[#D97642] transition-colors cursor-pointer py-2 uppercase tracking-wide text-sm">Home</Link>
            <Link to="/about" className="text-base font-medium text-white/90 hover:text-[#D97642] transition-colors cursor-pointer py-2 uppercase tracking-wide text-sm">About</Link>
            <Link to="/services" className="text-base font-medium text-white/90 hover:text-[#D97642] transition-colors cursor-pointer py-2 uppercase tracking-wide text-sm">Services</Link>
            <Link to="/contact" className="text-base font-medium text-white/90 hover:text-[#D97642] transition-colors cursor-pointer py-2 uppercase tracking-wide text-sm">Contact</Link>
          </div>
        </div>
      )}
    </nav>
  );
}
